import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";
import Select from "react-select";

const CreditDebitForm = (props) => {
  const frmRef = useRef({});
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const [taxs, setTaxs] = useState([]);
  const [data, setData] = useState([]);
  const [taxId, setTaxId] = useState();


  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          //// //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const { sendRequest: getSalesReturnInvoice } = useHttp();

  useEffect(() => {
    getSalesReturnInvoice(
      {
        url: `/api/salesInvoiceReturn/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          // //console.log(res);
        }
      }
    );
  }, [getSalesReturnInvoice]);

  const handleIdChange = (e) => {
    const id = e.target.value;
    if (id) {
      //console.log(id);

      const filterData =
        data && data.filter((item) => item.salesReturnInvoiceId == id);

      //// //console.log(filterData);

      frmRef.current.customer_id.value =
        filterData && filterData[0].customerCode;
      frmRef.current.email.value = filterData && filterData[0].emailId;
      frmRef.current.work_contact.value =
        filterData && filterData[0].workContactNumber;

      frmRef.current.customer_name.value = filterData && filterData[0].name;
      frmRef.current.sales_invoice_id.value =
        filterData && filterData[0].salesInvoiceId;
      frmRef.current.dnd_id.value = filterData && filterData[0].dndNo;
      frmRef.current.contact_person_name.value =
        filterData && filterData[0].customerContactPersonName;
      //  setProductDetails(filterData && filterData[0].salesInvoiceReturnProducts);
      setProductDetails(
        data &&
          data[0].salesInvoiceReturnProducts.map((x) => ({
            ...x,
            quantity: parseInt(x.salesReturnInvoiceQuantity),
            creditDebitProductId: generateId() + 1,
          }))
      );
      frmRef.current.total_amt.value = filterData && filterData[0].totalAmount;
      frmRef.current.total_cost.value =
        filterData && filterData[0].totalReturnCostValue;
      frmRef.current.amt_chargeable.value =
        filterData && filterData[0].amountChargeable;
      frmRef.current.tax_amt.value = filterData && filterData[0].taxAmount;
      frmRef.current.reason.value = filterData && filterData[0].reasonOfItem;
      frmRef.current.condition.value =
        filterData && filterData[0].conditionOfItem;
      frmRef.current.remark.value = filterData && filterData[0].remark;
      frmRef.current.delivery_date.value = moment(
        data && data[0].estimatedDeliveryDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
      frmRef.current.tax.value = filterData && filterData[0].taxId;
    }
  };

  function generateId() {
    const currentDate = moment().format("YYYYMMDD");
    const currentTime = moment().format("HHmmss");
    return `${currentDate}${currentTime}`;
  }

  const { sendRequest: postCreditDebit } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      creditDebitDetails: [
        {
          creditDebitId: generateId(),
          date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
          salesReturnInvoiceId: frmRef.current.sales_return_invoice_id.value,
          salesInvoiceId: frmRef.current.sales_invoice_id.value,
          creditDebitProducts: productDetails,
          taxId: frmRef.current.tax.value,
          taxAmount: frmRef.current.tax_amt.value,
          totalCreditCostValue: frmRef.current.total_cost.value,
          totalAmount: frmRef.current.total_amt.value,
          amountChargeable: frmRef.current.amt_chargeable.value,
          conditionOfItem: frmRef.current.condition.value,
          typeId: frmRef.current.note_type.value,
          reasonOfItem: frmRef.current.reason.value,
          remark: frmRef.current.remark.value,
          paidRecieved: false,
          status: 1,
          createdBy: parseInt(localStorage.getItem("id")),
          orgId: parseInt(localStorage.getItem("orgId")),
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        },
      ],
    };
    // //console.log(data);
    postCreditDebit(
      {
        url: "/api/salesCreditDebit/",
        method: "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);
        toast.success(`Note Done successfully`);
        props.addForm(false);
      }
    );
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "850px",
      maxHeight: "auto",
      height: "400px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Credit Debit Note Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"note_type"}> {"Note Type"}</label>
                      <select
                        id="note_type"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["note_type"] = el)}
                      >
                        <option value="1">Credit</option>
                        <option value="2">Debit</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sales_return_invoice_id"}>
                        {" "}
                        {"Sales Return Invoice No"}
                      </label>
                      <select
                        id="sales_return_invoice_id"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["sales_return_invoice_id"] = el)
                        }
                        onChange={handleIdChange}
                        required
                      >
                        <option value="">Select</option>
                        {data &&
                          data.map((x) => (
                            <option
                              key={x.salesReturnInvoiceId}
                              value={x.salesReturnInvoiceId}
                            >
                              {x.docNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sales_invoice_id"}>
                        {" "}
                        {"Sales Invoice Id"}
                      </label>
                      <input
                        type={"text"}
                        id={"sales_invoice_id"}
                        required
                        ref={(el) => (frmRef.current["sales_invoice_id"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"dnd_id"}>{"DnD id"}</label>
                      <input
                        type={"text"}
                        id={"dnd_id"}
                        required
                        ref={(el) => (frmRef.current["dnd_id"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"delivery_date"}>
                        {" "}
                        {"Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"delivery_date"}
                        required
                        ref={(el) => (frmRef.current["delivery_date"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>
                        {" "}
                        {"Customer Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"customer_name"}
                        required
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_id"}> {"Customer id"}</label>
                      <input
                        type={"text"}
                        id={"customer_id"}
                        required
                        ref={(el) => (frmRef.current["customer_id"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>{"Contact Number"}</label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {"Contact Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"contact_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setClose(true);
                        }}
                      >
                        View
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    {" "}
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"condition"}>
                        {" "}
                        {"Condition of Item"}
                      </label>
                      <select
                        id="condition"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["condition"] = el)}
                      >
                        <option value="Good">Good</option>
                        <option value="Moderate">Moderate</option>
                        <option value="Bad">Bad</option>
                        <option value="Very Bad">Very Bad</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reason"}>{"Reason of Return"}</label>
                      <select
                        id="reason"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["reason"] = el)}
                      >
                        <option value="Defective">Defective</option>
                        <option value="Packaging issue">Packaging issue</option>
                        <option value="Quality Issue">Quality Issue</option>
                        <option value="Other(Input)">Other(Input)</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-bordered table-responsive table-sm text-center">
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Unit Price</th>
                <th>Rate</th>
                <th>Item Quantity</th>
                <th>Sub Total</th>
                <th>Discount</th>
                <th>Discount Amount</th>

                <th>Unit</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.lineSrNo}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.itemType}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.itemUnitPrice}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.salesReturnInvoiceQuantity}</td>
                      <td>{itm.subTotalAmount}</td>
                      <td>{itm.discount}</td>
                      <td>{itm.discountAmount}</td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>{itm.totalLineAmount}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                setClose(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default CreditDebitForm;
